import { Component, ElementRef, HostListener, signal, WritableSignal } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { Router, RouterModule } from '@angular/router'

@Component({
  selector: 'gwc-mobile-menu',
  standalone: true,
  imports: [
    MatIconModule,
    RouterModule
  ],
  templateUrl: './mobile.menu.component.html',
  styleUrls: ['./mobile.menu.component.scss']
})
export class MobileMenuComponent {
  public isOpen: WritableSignal<boolean> = signal<boolean>(false)

  constructor(
    private elementRef: ElementRef,
    public router: Router	
  ) {}

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: HTMLElement): void {
    if (this.isOpen()) {
      const clickedInside = this.elementRef.nativeElement.contains(targetElement)
      if (!clickedInside) {
        this.closeMenu()
      }
    }
  }

  public toggleMenu() {
    this.isOpen.update(value => !value)
  }

  public closeMenu() {
    this.isOpen.set(false)
  }
}
